  // 찾아오시는 길 네이버 지도 공통 스크립트 각 jsp 에서 주소를 입력해 사용 가능하도록 함수 정의
  
  // 주소 기반 좌표 변환 - 우편번호, 상세주소는 제거하고 실제 주소만 전달해야 정확한 위치를 얻을 수 있습니다.
  function getCoordsByAddress(address, callback) {
    naver.maps.Service.geocode({ query: address }, function(status, response) {
      if (status !== naver.maps.Service.Status.OK) {
        console.error("주소 변환 실패:", status);
        callback(null);
        return;
      }

      const result = response.v2.addresses[0];
      if (result) {
        callback({
          lat: parseFloat(result.y),
          lng: parseFloat(result.x),
        });
      } else {
        callback(null);
      }
    });
  }

  // 지도 표시
  function initNaverMap(container, { lat, lng, level = 15 }) {
    const map = new naver.maps.Map(container, {
      center: new naver.maps.LatLng(lat, lng),
      zoom: level, // 줌 레벨 설정  
      // mapTypeControl: true, // 지도/위성 버튼 노출
      zoomControl: true, // 줌 컨트롤 노출
      zoomControlOptions: {
        style: naver.maps.ZoomControlStyle.SMALL,
        position: naver.maps.Position.TOP_RIGHT
      },
    });

    new naver.maps.Marker({
      position: new naver.maps.LatLng(lat, lng),
      map: map,
    });
  }